const en_master_groups = {
    add: "add group",
    edit: "edit group",
    name: "group name",

    error: {
        category: "Group category cannot be empty.",
        create: "Failed to create group.",
        delete: "Failed to delete group.",
        edit: "Failed to update group.",
        name: "Group name cannot be empty.",
        po_duration: "Pre-order duration must be greater than 0.",
        unit: "Group unit cannot be empty.",
        type: "Group type cannot be empty.",
        whs1: "Group warehouse cannot be empty.",
        whs2: "At least 1 warehouse is required.",
    },

    success: {
        create: "Group created successfully.",
        delete: "Group deleted successfully.",
        edit: "Group updated successfully.",
    }
}

export default en_master_groups